// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { akEditorLineHeight } from '@atlaskit/editor-shared-styles';
// @see typography spreadsheet: https://docs.google.com/spreadsheets/d/1iYusRGCT4PoPfvxbJ8NrgjtfFgXLm5lpDWXzjua1W2E/edit#gid=93913128
export var ruleSharedStyles = function ruleSharedStyles() {
  return css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& hr': {
      border: 'none',
      backgroundColor: "var(--ds-border, #091E4224)",
      // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      margin: "".concat(akEditorLineHeight, "em 0"),
      height: '2px',
      borderRadius: '1px'
    }
  });
};